import React from "react"
import { Title } from "@motorata/base-ui.components.atoms.typography"
import styled from "styled-components"
import Link from "@motorata/next.components.atoms.link";
import { blockStyles, Box } from "@motorata/base-ui.components.atoms._atoms";
import { OfferType } from "@motorata/base-ui.types.api";
import OffersSliderSection from "@/components/sections/OffersSliderSection";

const HomeOffers = ({ offers }: {
  offers: {
    title: string
    offers: OfferType[]
  }[]
}) => {
  return (
    <Wrapper>
      <Title label="Promocja" center>
        Sprawdź proponowane oferty
      </Title>
      <Content>
        {
          offers.map((el, index) =>
            <Box key={index} marginTop="M" marginBottom="M">
              <OffersSliderSection title={el.title} offers={el.offers} />
            </Box>
          )
        }
      </Content>
      <Link href="/oferty" type="secondary" width="100%" marginTop="S">
        Wszystkie oferty
      </Link>
    </Wrapper>
  )
}

export default HomeOffers

const Content = styled.div`
`

const Wrapper = styled.div`
  ${blockStyles};
  max-width: 1200px;
`
